import agenda from './components/agenda.js'
import appointment from './components/appointment.js'
import customer from './components/customer.js'
import checkout from './components/checkout.js'
import gifts from './components/gifts.js'
import onboarding from './components/onboarding.js'
import promotion from './components/promotion.js'
import profile from './components/profile.js'
import settings from './components/settings.js'
import sales from './components/sales.js'
import service from './components/service.js'
import combos from './components/combos.js'
import inventory from './components/inventory.js'
import mediaGallery from './components/media-gallery.js'
import shifts from './components/shifts.js'
import staff from './components/staff.js'
import booksyApp from './components/booksy-app.js'
import advancedOptions from './components/advanced-options.js'
import payments from './components/payments.js'
import healthSafetyRules from './components/health-safety-rules.js'
import booksyAwards from './components/booksy-awards.js'
import turnTracker from './components/turn-tracker.js'
import waitlist from './components/waitlist.js'
import walkthroughs from './components/walkthroughs.js'
import calendar from './components/calendar.js'
import repeating from './components/repeating.js'
import subscription from './components/subscription.js'
import routes from './components/routes.js'
import tutorials from './components/tutorials.js'

import booksyVueComponents from '../booksy-vue-components/messages/en.json'

export default {

  ...booksyVueComponents,

  /*
   *
   * messages for components...
   *
   */
  components: {

    agenda: agenda,

    appointment: appointment,

    customer: customer,

    checkout: checkout,

    gifts: gifts,

    onboarding: onboarding,

    promotion: promotion,

    profile: profile,

    settings: settings,

    sales: sales,

    service: service,

    combos: combos,

    inventory: inventory,

    'media-gallery': mediaGallery,

    shifts: shifts,

    staff: staff,

    'booksy-app': booksyApp,

    'advanced-options': advancedOptions,

    payments: payments,

    'health-safety-rules': healthSafetyRules,

    'booksy-awards': booksyAwards,

    'turn-tracker': turnTracker,

    'waitlist': waitlist,

    'walkthroughs': walkthroughs,

    'switch-bar': {
      title: {
        'phase_3_done': 'You\'re using Booksy Biz Pro. Tell us what you like about it.',
      },
      soon: 'soon',
      feedback: 'Send feedback',
      modals: {
        feedback: {
          title: 'Send Feedback',
          intro: 'We would love to hear more about your Early Access experience so that we can continue to make improvements. Let us know what you like and what could improve.',
          'tell-us-more': 'Tell us more ...',
          question: 'Are you enjoying Booksy Biz Pro?',
        },
      },
    },

    'online-booking-bar': {
      'title': 'Online Bookings are turned off. Enable it now to say goodbye to interruptions.',
      'button': 'enable online booking',
    },

    'activate-booksy-med-bar': {
      'title': 'Activate Booksy Med and start using it today!',
      'button': 'Activate Booksy Med',
    },

    'search-visibility-bar': {
      'title': 'Search Visibility is currently disabled. Enable it now to let clients find you.',
      'button': 'enable search visibility',
    },

    'walkthrough-profile-bar': {
      title: {
        'delay-in-days': '{daysCounter} until your profile goes live. Check everything is ready for clients to start booking.',
        'days-counter': '{count} day | {count} days | {count} days',
        'delay-soon': 'Your profile will go live soon. Check everything is ready for clients to start booking.',
        'profile-live': 'Your profile is now live! Check everything is ready for clients to start booking.',
      },
      'cta-label': 'Check profile',
    },

    'visible-delay': {
      title: 'Your profile will go live in {daysCounter} - Make sure your profile is setup properly',
      'days-counter': '{count} day | {count} days | {count} days',
      support: 'I need support',
    },

    'demo-account-bar': {
      'title': 'Check out the available features. You can change the account settings and data but please remember not to enter your clients’ real details.',
      'description': 'Your demo account will be active until {date}',
    },

    'tap-to-pay-bar': {
      'title': 'Try using No-Show Protection to safeguard your money and prevent unreliable clients from wasting your time.',
      'mobile-title': 'Discover No-show Protection.',
      'show-more': 'Show more',
    },

    'blik-promo-bar': {
      'title': 'Your clients can now prepay with BLIK!',
      'title-for-zero-prop': 'You can now accept BLIK prepayments for free! Enable No-Show Protection.',
      'description': 'Enable No-Show Protection today.',
      'show-more': 'Show more',
    },

    'ttp-reminder-bar': {
      'title': `Don't miss out on this deal...`,
      'show-more': 'Show more',
    },

    'money-in-account-bar': {
      'title': `Hey, there's {amount} in your account.`,
      'description': 'Add payout details now to receive your money.',
      'show-more': 'Add',
    },

    common: {
      'b-image-upload': {
        'crop': 'Submit image',
      },
      'b-image-slider': {
        'delete-image': 'Delete Photo?',
        'delete-image-description': 'This cannot be undone',
        'of': 'of',
      },
      'b-appointment': {
        'redo': 'redo',
      },
      'b-cropper': {
        'description': 'Adjust the size of the grid to crop your image. You can also drag your photo to reposition it.',
        'multi': {
          'title': 'Adjust photos ({index} of {length})',
          'next': 'Save and continue',
        },
      },
      'b-loader': {
        'modal-title': 'Booksy unresponsive',
        'modal-description': 'Booksy PRO has become unresponsive.<br>You can wait for it or reload application.',
        'wait': 'wait',
        'reload': 'reload',
      },
      'b-date-picker': {
        'jump-by-week': 'Jump By Week',
      },
    },

    app: {
      modals: {
        'account-settings': {
          'switch-business': 'Switch Business',
          'logged-as': 'Logged as',
        },
        'ecommerce': {
          'title': 'Store = saving time and money 💸',
          'description': '✅ Everything you need in one place – choose from 10,000 products \n 🛍️ Top brands at attractive prices \n ⚡ Quick shopping of professional products you use every day \n 💰 Using the platform is completely free',
          'confirm-btn': 'Start shopping!',
        },
        'product-suggestions': {
          'title': 'Today\'s promotions on Booksy',
        },
        'bgc-walkthrough': {
          'title': 'New booking with a Booksy Gift Card',
          'description': 'Someone just booked an appointment with you using a Booksy Gift Card. View a quick guide on how to receive the funds from the card.',
          'confirm-btn': 'See how to get paid',
          'skip-btn': 'Skip',
          'see-guide-btn': 'See the guide',
          'skip-confirm-title': 'Are you sure you want to skip?',
          'skip-confirm-description': 'We\'ll show you how to ensure the Gift Card funds reach your balance. You can view these instructions later in the appointment details.',
        },
        'receipt': {
          'send-receipt': 'Send receipt to client via e-mail',
          'email': 'Email',
          'confirm-refund': 'Confirm full refund?',
          'confirm-refund-text': 'You are about to refund the full amount of this transaction. Standard processing fees apply. Do you want to continue?',
          'confirm-button': 'Refund payment',
          back: 'Go back',
          'confirm-full-refund': 'Confirm full refund?',
          'confirm-refund-with-fee-text': 'You are about to issue a full refund for this transaction. Please note, a refund fee of {fee} will apply. Continue with refund?',
          'refund-request-sent': 'Refund request sent!',
          'sent-to-the-printer': 'Sent to the printer',
          'commission-share': 'Commission Share',
          'cannot-send-info': 'Email cannot be sent to a customer with an email address locked.',
          'cannot-print-receipt': 'Your permission level doesn\'t allow you to perform this action.',
          'cancel': {
            'title': 'Cancel payment?',
            'text': 'If you cancel this payment, the transaction will not be processed.',
            'confirm': 'Cancel Payment',
          },
        },
        'refund': {
          'title': 'Refund payment',
          'description': 'Issue a full or partial refund for this payment. A standard transaction fee applies to the refunded amount.',
          'full-refund': 'Full refund',
          'partial-refund': 'Partial refund',
          'btn-refund': 'Refund payment',
          'btn-go-back': 'Go back',
          'total-refund': 'Total refund:',
          'partial-refund-placeholder': 'Amount',
          'partial-refund-max-error': 'Enter an amount up to {amount}.',
          'partial-refund-available': 'Available to refund: {amount}',
          'confirm-title': 'Issue this refund?',
          'confirm-partial-refund': 'You are about to refund a partial amount of {amount} to the client. Please note, a refund fee of {fee} applies. Continue with refund?',
          'confirm-full-refund': 'You are about to refund the full amount of {amount} to the client. Please note, a refund fee of {fee} applies. Continue with refund?',
          'btn-issue-refund': 'Issue refund',
          'refund-request-sent': 'Refund request sent!',
        },
        'common': {
          'shift-warnings': {
            'adjust': 'Update',
            'dont-adjust': 'Don\'t Update',
            'apply-new-shift': 'Apply changes',
            'apply-time-off': 'Apply time off',
            'apply-new-working-hours': 'Apply new working hours',
            'apply-new-opening-hours': 'Apply new business hours',
            'edit-appointments': 'I want to edit appointments first',
            'ok': 'Got it',
          },
          'online-booking-disabled': {
            'title': 'Online booking will be disabled',
            'top-paragraph': 'To have online booking enabled, you need to meet the following requirements:',
            'bottom-paragraph': 'If you continue, at least one of them will not be fulfilled and online booking will be disabled. Are you sure you want to continue?',
            'back-to-editing': 'back to editing',
          },
          'unable-to-make-change': {
            'title': 'Unable to make the change',
            'content': 'The change you are trying to make would result in disabling online booking. You need to have at least one service connected to a Staff Member available online to be on Booksy. <br><br>You have recently scheduled sending invites to your clients and therefore cannot disable the option for 3 days after the last invite is sent.</br></br>',
          },
        },
        'adyen-to-stripe-consent': {
          'variant-a': {
            title: 'Payment Processor Update',
            subtitle: 'We are changing our Payment Processor to Stripe - a leader in payment solutions.',
            paragraph1: 'To make this change, we need your consent to transfer your data to Stripe. No need to fill out more forms. We\'ll take care of everything and we\'ll ensure your data remains secure and protected throughout the transfer.',
            paragraph2: 'Please agree to the transfer before <strong>{dueDate}</strong>. If you have not agreed by that date, you will no longer have access to Mobile Payments and No-Show Protection.',
          },
          'variant-b': {
            title: 'Payment Processor Update',
            paragraph1: 'We are changing our Payment Processor to Stripe - a leader in payment solutions. This will allow Booksy to:',
            item1: '• Offer next business day payouts',
            item2: '• Improve your overall experience',
            item3: '• Simplify how you access Payments within the app',
            paragraph2: 'To make this change, we need your consent to transfer your data to Stripe before <strong>{dueDate}</strong>. If you have not agreed by that date, you will no longer have access to Mobile Payments and No-Show Protection',
            paragraph3: 'Your data will remain secure and protected throughout the transfer.',
            paragraph4: 'No need to fill out more forms. We\'ll take care of everything.',
          },
          'variant-c': {
            title: 'Payment Processor Update',
            paragraph1: 'We are changing our Payment Processor to Stripe - a leader in payment solutions. This will allow Booksy to:',
            item1: '• Offer next business day payouts',
            item2: '• Improve your overall experience',
            item3: '• Simplify how you access Payments within the app',
            paragraph2: 'To make this change, we need your consent to transfer your data to Stripe before <strong>{dueDate}</strong>. If you have not agreed by that date, you will no longer have access to Mobile Payments and No-Show Protection.',
            paragraph3: 'Your data will remain secure and protected throughout the transfer.',
            paragraph4: 'No need to fill out more forms. We\'ll take care of everything.',
          },
          success: {
            paragraph1: 'Your data will be transferred to our payment processor, Stripe. Once the transition is complete, you will be notified via email.',
            paragraph2: 'In the meantime, keep doing what you do best.',
          },
          annotation: 'By clicking “Agree” you accept the <a href="{stripeTermsUrl}"><strong>Stripe Terms and Conditions</strong></a>.',
          toast: {
            'no-permission': 'You don’t have the required permission to perform this action.',
            'already-agreed': 'You have already given your consent.',
            'not-required': 'Your consent related to this payment processor is not required.',
          },
        },
        'dac7': {
          'pesel': {
            'placeholder': 'PESEL',
            'content-confirm': 'Confirm and save',
            'content-title': 'Complete missing details',
            'content-description': 'In accordance with the EU DAC7 directive, we are required to collect certain details about your business. Please complete the information below to maintain the visibility of your profile in the client application. <a href="{link}" target="blank"><strong><u>Find out more about DAC7.</u></strong></a>.',
            'status-title': 'Details saved',
            'status-description': 'Thank you for completing the missing details. To learn more about DAC7, please visit our <a href="{link}" target="blank"><strong><u>Help Center</u></strong></a>.',
          },
          'company-pl': {
            'name-field-placeholder': 'Name or company name',
            'address-field-placeholder': 'Business address',
            'zip-code-field-placeholder': 'Post code',
            'city-field-placeholder': 'City',
            'country-field-placeholder': 'Country',
            'nip-or-pesel-field-placeholder': 'Tax ID or PESEL (if there is no tax ID)',
            'regon-field-placeholder': 'REGON (only for companies)',
            'country-tax-residence-field-placeholder': 'Country of tax residence',
            'birthday-field-placeholder': 'Date of birth',
            'birthday-field-hint': 'Date of birth of the individual, or of the requester in the case of a company.',
            'content-confirm': 'Confirm and save',
            'content-disclaimer': 'The data provided is true and accurate',
            'content-title': 'Complete missing details',
            'content-description': 'In accordance with the EU DAC7 directive, we are required to collect certain details about your business. Please complete the information below to maintain the visibility of your profile in the client application. <a href="{link}" target="blank"><strong><u>Find out more about DAC7</u></strong></a>.',
            'status-title': 'Details saved',
            'status-description': 'Thank you for completing the missing details. To learn more about DAC7, please visit our <a href="{link}" target="blank"><strong><u>Help Center</u></strong></a>.',
          },
          'birthday': {
            'birthday-field-placeholder': 'Date of birth',
            'content-confirm': 'Confirm and save',
            'content-title': 'Complete missing details',
            'content-description': 'In accordance with the EU DAC7 directive, we are required to collect certain details about your business. Please complete the information below to maintain the visibility of your profile in the client application. <a href="{link}" target="blank"><strong><u>Find out more about DAC7</u></strong></a>.',
            'status-title': 'Details saved',
            'status-description': 'Thank you for completing the missing details. To learn more about DAC7, please visit our <a href="{link}" target="blank"><strong><u>Help Center</u></strong></a>.',
          },
          'company-es': {
            'business-type-individual': 'Individual',
            'business-type-entity': 'Entity',
            'name-field-placeholder': 'Name',
            'company-name-field-placeholder': 'Company name',
            'address-field-placeholder': 'Business address',
            'zip-code-field-placeholder': 'Post code',
            'city-field-placeholder': 'City',
            'country-field-placeholder': 'Country',
            'nif-or-dni-field-placeholder': 'NIF or DNI (if there is no NIF)',
            'nif-iva-field-placeholder': 'NIF-IVA (only for companies)',
            'country-tax-residence-field-placeholder': 'Country of tax residence',
            'birthday-field-placeholder': 'Date of birth',
            'content-confirm': 'Confirm and save',
            'content-disclaimer': 'The data provided is true and accurate',
            'content-title': 'Complete missing details',
            'content-description': 'In accordance with the EU DAC7 directive, we are required to collect certain details about your business. Please complete the information below to maintain the visibility of your profile in the client application. <a href="{link}" target="blank"><strong><u>Find out more about DAC7</u></strong></a>.',
            'status-title': 'Details saved',
            'status-description': 'Thank you for completing the missing details. To learn more about DAC7, please visit our <a href="{link}" target="blank"><strong><u>Help Center</u></strong></a>.',
          },
          'company-fr': {
            'business-type-individual': 'Individual',
            'business-type-entity': 'Entity',
            'name-field-placeholder': 'Name',
            'company-name-field-placeholder': 'Company name',
            'address-field-placeholder': 'Business address',
            'zip-code-field-placeholder': 'Post code',
            'city-field-placeholder': 'City',
            'country-field-placeholder': 'Country',
            'nif-or-nir-or-siren-field-placeholder': 'NIF or NIR or SIREN',
            'nif-or-nir-or-siren-field-hint': '<a href="{link}" target="blank"><strong><u>Click here</u></strong></a> to check where to find your NIF.',
            'country-tax-residence-field-placeholder': 'Country of tax residence',
            'birthday-field-placeholder': 'Date of birth',
            'content-confirm': 'Confirm and save',
            'content-disclaimer': 'The data provided is true and accurate',
            'content-title': 'Keep your account up to date to stay compliant!',
            'content-description': 'In order to meet current regulations, we ask you to please take a moment to review and update your company information. This ensures your account remains compliant with the support of our services.',
            'status-title': 'Thank you for updating!',
            'status-description': 'Your information has been successfully updated. If you have any questions, please don\'t hesitate to contact our team.',
          },
          'company-pl-v2': {
            'business-type-individual': 'Individual',
            'business-type-entity': 'Entity',
            'company-name-field-placeholder': 'Company name',
            'first-name-field-placeholder': 'First name',
            'last-name-field-placeholder': 'Last name',
            'address-field-placeholder': 'Business address',
            'zip-code-field-placeholder': 'Post code',
            'city-field-placeholder': 'City',
            'country-field-placeholder': 'Country',
            'nip-or-pesel-field-placeholder': 'Tax ID or PESEL (if there is no tax ID)',
            'regon-field-placeholder': 'REGON (only for companies)',
            'country-tax-residence-field-placeholder': 'Country of tax residence',
            'birthday-field-placeholder': 'Date of birth',
            'birthday-field-hint': 'Date of birth of the individual, or of the requester in the case of a company.',
            'content-confirm': 'Confirm and save',
            'content-title': 'Complete missing details',
            'content-description': 'In accordance with the EU DAC7 directive, we are required to collect certain details about your business. Please complete the information below. Otherwise, <strong>payouts from Booksy Payments will be blocked</strong> or, if you use the Booksy Fiscalization add-on, <strong>your profile will be hidden in the Booksy for Customers app until you complete the details.</strong> <a href="{link}" target="blank"><strong><u>Find out more about DAC7</u></strong></a>.',
            'status-title': 'Details saved',
            'status-description': 'Thank you for completing the missing details. To learn more about DAC7, please visit our <a href="{link}" target="blank"><strong><u>Help Center</u></strong></a>.',
          },
          'company-es-v2': {
            'business-type-individual': 'Individual',
            'business-type-entity': 'Entity',
            'name-field-placeholder': 'Name',
            'company-name-field-placeholder': 'Company name',
            'first-name-field-placeholder': 'First name',
            'last-name-field-placeholder': 'Last name',
            'address-field-placeholder': 'Business address',
            'zip-code-field-placeholder': 'Post code',
            'city-field-placeholder': 'City',
            'country-field-placeholder': 'Country',
            'nif-or-dni-field-placeholder': 'NIF or DNI (if there is no NIF)',
            'nif-iva-field-placeholder': 'NIF-IVA (only for companies)',
            'country-tax-residence-field-placeholder': 'Country of tax residence',
            'birthday-field-placeholder': 'Date of birth',
            'content-confirm': 'Confirm and save',
            'content-title': 'Complete missing details',
            'content-description': 'In accordance with the EU DAC7 directive, we are required to collect certain details about your business. Please complete the information below. Otherwise, <strong>payouts from Booksy Payments will be blocked</strong> until you complete the details. <a href="{link}" target="blank"><strong><u>Find out more about DAC7</u></strong></a>.',
            'status-title': 'Details saved',
            'status-description': 'Thank you for completing the missing details. To learn more about DAC7, please visit our <a href="{link}" target="blank"><strong><u>Help Center</u></strong></a>.',
          },
          'company-fr-v2': {
            'business-type-individual': 'Individual',
            'business-type-entity': 'Entity',
            'name-field-placeholder': 'Name',
            'company-name-field-placeholder': 'Company name',
            'first-name-field-placeholder': 'First name',
            'last-name-field-placeholder': 'Last name',
            'address-field-placeholder': 'Business address',
            'zip-code-field-placeholder': 'Post code',
            'city-field-placeholder': 'City',
            'country-field-placeholder': 'Country',
            'nif-or-nir-or-siren-field-placeholder': 'NIF or NIR or SIREN',
            'nif-or-nir-or-siren-field-hint': '<a href="{link}" target="blank"><strong><u>Click here</u></strong></a> to check where to find your NIF.',
            'country-tax-residence-field-placeholder': 'Country of tax residence',
            'birthday-field-placeholder': 'Date of birth',
            'content-confirm': 'Confirm and save',
            'content-title': 'Keep your account up to date to stay compliant!',
            'content-description': 'In accordance with the EU DAC7 directive, we are required to collect certain details about your business. Please complete the information below. Otherwise, <strong>payouts from Booksy Payments will be blocked</strong> or, if you use the Booksy Fiscalization add-on, <strong>your profile will be hidden in the Booksy for Customers app</strong> until you complete the details. <a href="{link}" target="blank"><strong><u>Find out more about DAC7</u></strong>',
            'status-title': 'Thank you for updating!',
            'status-description': 'Your information has been successfully updated. If you have any questions, please don\'t hesitate to contact our team.',
          },
        },
        'mandatory-field': 'The provision of this data is mandatory',
      },
    },

    shared: {
      'personal-settings': {
        'currently-using': 'Currently using',
      },
      'opening-hours-schedule': {
        'closed': 'Closed',
        'breaks': 'Breaks',
        'break': 'Break',
      },
      'payment-receipt': {
        'item': 'Item',
        'amount': 'Amount',
        'total': 'Total',
        'total-paid': 'Total Paid',
        'receipt': 'Receipt',
        'refund': 'Refund',
        'invoice-no': 'Invoice No.',
        'redeemed': 'Redeemed',
        'cancel-payment': 'Cancel Payment',
        'refunded-by': 'Refund processed by:',
      },
      'sales-navigation': {
        'checkout': 'New Sale',
        'transactions': 'Transactions',
        'cash-registers': 'Cash Registers',
        'invoices': 'Invoices',
        'fiscal-receipts': 'Transactions',
        'fiscal-archives': 'Archives',
      },
      'schedule-day-edit': {
        'starts': 'Start',
        'ends': 'End',
        'add-break': 'Add Break',
        'break': 'Break',
        'conflict-with-shift': 'Conflict with shift',
        'conflict-with-hours': 'Conflict with hours',
        'open': 'Open',
        'shift': 'Shift',
        'opening-hours': 'Opening hours',
      },
      'apply-hours-from': {
        'choose': 'Timeframe',
        'choose-date': 'Choose date',
        'immediately': 'Immediately',
        'starting-next-week': 'Next Week',
        'other': 'Custom',
      },
      'scope-picker': {
        'last-7-days': '7 days',
        'last-14-days': '14 days',
        'last-30-days': '30 days',
        'last-3-months': '3 months',
        'last-6-months': '6 months',
        'billing-cycle-text': 'Your current billing cycle is {startDate} - {endDate}.',
        'checkbox-label': 'Billing cycle',
      },
      'social-share-drawer': {
        'title': 'Share completed',
        'text': 'Your followers will now see true talent you put in your work!',
        'copy-to-clipboard-text': 'Hashtags copied to clipboard!',
      },
      'hours': {
        'search-placeholder': 'Select value or start typing',
      },
      modals: {
        'note-modal': {
          'add-note': 'Add Note',
          'note': 'Note',
        },
        'services-selector': {
          'all-services': 'All Services',
          'categories': 'Categories',
          'options': '{count} variant | {count} variants | {count} variants',
          'available-options': 'from {count} available | from {count} available | from {count} available',
          'prepayment': 'Deposit · {value}',
          'cancellation-fee': 'Cancellation fee · {value}',
          'mobile-services': 'Mobile Services',
          'staffer-variants-message': 'To edit staff assignments for Service Variants, go to',
          'staffer-variants-link': 'Services Setup',
          'not-eligible': 'Not Eligible',
        },
        'business-pin-outside-soft-limit': {
          'title': 'Are you sure the pin is in the right place?',
          'text': 'Putting the pin in the right place will make it easy for your customers to find your business.',
          'adjust-pin': 'Adjust pin',
        },
        'business-pin-outside-country': {
          'title': 'Are you sure the pin is in the right place?',
          'text': 'Your pin is in a different country than the address for your business. Move the pin so your customers can easily find you.',
          'adjust-pin': 'Adjust pin',
        },
        'booksy-pay-refunds-modal': {
          'title': 'We\'ve improved Booksy Pay refunds for you',
          'subtitle': 'What\'s changed?',
          'section-1-title': 'You decide on late client cancellations',
          'section-1-item-1': 'Approve these refund requests directly from the appointment. You have 30 days to decide.',
          'section-1-item-2': 'We\'ll explain your cancellation policy to clients when they try to cancel.',
          'section-2-title': 'Simpler refunds for timely cancellations',
          'section-2-item-1': 'These now process automatically, saving you manual work.',
          'section-3-title': 'Stay informed',
          'section-3-item-1': 'You\'ll get notifications for all refund activities.',
          'section-3-item-2': 'See a full transaction history in your Booksy Wallet.',
          'learn-more': 'Learn more',
          'got-it': 'Got it',
        },
        'booksy-pay-activation-modal': {
          'title': 'Get Booksy Pay for free for one year',
          'description': 'Let clients pay flexibly—upfront or after their appointment—with a card, BLIK, Apple Pay, Google Pay, and Klarna.',
          'learn-more': 'Learn more',
        },
      },
      'download-app-modal': {
        'title': 'Use Booksy in…',
        'subtitle': 'Booksy Biz app',
      },
      'boost-terms-button': {
        'terms-info': 'By activating Boost, you agree to the',
        'terms': 'Boost Terms & Conditions',
      },
    },

    calendar: calendar,

    repeating: repeating,

    subscription,

    'side-menu': {
      'homepage': 'Homepage',
      'appointments': 'Appointments',
      'shifts': 'Shifts',
      'checkout': 'Checkout',
      'clients': 'Clients',
      'gifts': 'Gift Cards & Bundled Services',
      'gifts-only': 'Gift Cards',
      'business-settings': 'Business Settings',
      'marketing': 'Marketing',
      'inventory': 'Inventory',
      'reports': 'Reports',
      'profile': 'Profile',
      'staff-members': 'Staff Management & Resources',
      'elearning': 'Booksy Library',
      'helpshift': 'Support',
      'turn-tracker': 'Turn Tracker',
      'select-language': 'Select language',
      'business-wallet': 'Business Wallet',
      'personal-wallet': 'Personal Wallet',
      'booksy-wallet-badge': 'New',
    },

    'customers-list': {
      'invite-button': 'Invite to book',
      'invite-all': 'Invite all',
      'search-clients': 'Search clients',
      'invited': 'Already invited',
      'group': {
        'all_customers': 'All Clients',
        'search_by_booking': 'Search by Booking',
        'new_customers': 'Clients registered in the last 30 days',
        'most_loyal': 'Clients with at least three visits in the last three months',
        'upcoming_birthdays': 'Clients with birthdays this coming week',
        'slipping_away': 'Clients who have not booked within the last month',
        'zero_bookings_count': 'Clients who haven\'t booked with you yet',
        'first_visit': 'Clients who have booked their first visit',
        'active_gift_cards': 'Clients with active gift cards',
        'not_booksy_users': 'Clients who are not using the Booksy App',
      },
      'statuses': {
        'no_bookings': 'No bookings',
        'recently_invited': 'Invited recently',
        'no_respond': 'No response',
        'not_invited': 'Not invited',
        'invite_pending': 'Invitation pending',
      },
      'modal': {
        'single-customer-title': 'Client invited',
        'content': 'Good job spreading the word. Be on the lookout for new bookings.',
        'invite-all-title': 'Inviting clients in progress',
        'invite-all-content': 'We are in the process of inviting your clients. In the meantime you can continue using the Booksy app',
        'invite-all-button': 'Continue using app',
        'button': 'Got it',
      },
    },

    tutorials,

    notifications: {
      'drawer-title': 'Notifications',
    },

    'stories-button': {
      'button-content': 'How it works',
      'learn-more': 'Learn more',
    },
  },

  /*
   *
   * messages for views...
   *
   */
  views: {

    error: {

      404: {
        title: 'Oops! Page not found...',
        description: 'The page you are looking for might have been removed had it’s name changed or is temporary unavailable.',
      },

      403: {
        title: 'Access Denied',
        description: 'You have no permission to use this feature',
      },
    },

    'download-app': {
      title: 'Download Booksy App',
      description: 'To use Booksy on your smartphone, please download the Booksy mobile app. Otherwise, you can sign in via a web browser on your computer.',
      btn: 'Download app',
    },

    'mobile-app-installed': {
      title: 'You’ve Got Two Apps',
      description: 'We noticed you’re using both the mobile app (Booksy Biz) and the tablet app (Booksy Biz Pro) on your iPad. For the best experience, delete the mobile app from your tablet. Everything you need is here on Pro.',
      cta: 'Got it',
    },

    'connection-problem': {
      'no-network-connection': {
        'title': 'Check your internet connection',
        'info': 'It looks like you\'re not connected to the internet right now. Check your WiFi/mobile network and try again.',
      },
      'no-server-connection': {
        'title': 'We\'re having trouble connecting',
        'info': 'We\'re sorry about this. We can\'t connect to the Booksy server right now. We\'re working to fix it though, so please try again in a few minutes.',
      },
    },

    'maintenance-mode': {
      'incident': {
        title: 'We\'re working on it',
        text1: 'Our service is temporarily unavailable, but we\'ll be back soon.',
        text2: 'Thank you for your patience.',
        button: 'Refresh',
      },
      'scheduled': {
        title: 'We\'ll be back soon<br />(and better than ever)',
        text1: 'Booksy is currently not available due to scheduled maintenance work',
        text2: 'Thank you for your patience.',
        button: 'Refresh',
      },
    },

    business: {
      customers: {
        'list': 'list',
        'groups': 'groups',
      },

      settings: {
        services: {
          title: 'Services',
        },
        'custom-forms': {
          list: {
            'search-placeholder': 'Search in Custom Forms…',
          },
          form: {
            'title-add-form': 'Add Custom Form',
            'title-edit-form': 'Edit Custom Form',
            'fields-error': 'There should be at least one field',
            'delete-form': 'Delete this form?',
            'title-length-message': 'Ensure this field has no more than 100 characters.',
            'preview': 'Preview',
          },
        },
        'advanced-options': {
          'pos-retail': {
            'title': 'Point of Sale & Retail',
            'retail-settings': 'Retail Settings',
            'enable-cash-register': 'Enable cash register',
            'enable-cash-register-hint': 'This feature allows you to control the cash flow in your shop and account for all checked out money.',
            'enable-tips': 'Enable staff tips',
            'enable-stock-control': 'Enable stock control',
            'enable-stock-control-hint': 'Enabling this feature will allow you to both manually and automatically monitor inventory numbers as products are sold or stocked. Note: Booksy will always allow a product to be added to a cart, even if the inventory equals 0.',
            'tip-settings': 'Tips Settings',
            'tax-settings': 'Tax Settings',
            'default-tip': 'Default tip',
            'no-tip': 'No tip',
            'add-tip-rate': 'Add Tip Rate',
            'tax-rates': 'Tax Rates',
            'default-service-tax': 'Default service tax',
            'default-tax-hint': 'Default tax rates will automatically be applied to newly added products/services. Pre-existing products/services will not be affected, unless you click \'Apply default tax for all\' or edit the tax manually on the individual product/service pages.',
            'default-product-tax': 'Default product tax',
            'default': 'Default',
            'tax-free': 'Tax Free',
            'add-tax-rate': 'Add Tax Rate',
            'set-receipt-footer': 'Set receipt footer',
            'receipt-footer': 'Footer Text',
            'tip-rate': 'Tip rate',
            'tax-rate': 'Tax rate',
            'apply-default-to-services': 'Apply new default tax to all existing services?',
            'apply-default-to-products': 'Apply new default tax to all existing products?',
            'yes-apply': 'Yes, apply',
          },
          'document-numbering': {
            'title': 'Document Numbering',
            'prefix': 'Prefix',
            'number': 'Number',
          },
        },
      },

      gifts: {
        title: 'Gift Cards & Bundled Services',
        'title-cards-only': 'Gift Cards',
        'gift-cards-box': 'Gift Cards',
        'memberships-box': 'Memberships',
        'packages-box': 'Packages',
        'gift-cards': {
          'orders': 'Pending Orders ({count})',
          'purchased': 'Purchased',
          'completed-orders': 'Completed Orders',
          'manage-gift-cards': 'Manage Gift Cards',
          'payment-details': 'Payment details',
          'purchase-methods': 'Purchase methods',
        },
        'memberships': {
          'purchased': 'Purchased',
          'available-memberships': 'Manage Memberships',
        },
        'packages': {
          'purchased': 'Purchased',
          'available-packages': 'Manage Packages',
        },
      },
      promotion: {
        'boost': {
          'title': 'Boost',
          'summary-heading': 'Lifetime Boost Revenue',
          'boost-details': {
            'title': 'Boost Details',
          },
          'boost-promoted': {
            title: 'Get Promoted',
            text: 'When you activate Boost you\'ll secure a higher ranking on the Booksy search engine and increase your exposure. But that s not all.<br/><br/> Consider the Boost team like your mini marketing department. Leveraging our search engine, galleries, special badges, ads, blog, and newsletters we\'ll help you show off your talent(s) to potential customers.<br/><br/>You get to focus on doing what you love and enjoy the bookings that come as a result.',
            'recommended': 'Recommended by Booksy',
          },
          'boost-share': {
            title: 'Share Your Link',
            'text': 'Use your unique link below to separate existing clients from new clients who find you through Boost.<br/><br/>When a new client books an appointment through your unique link you won\'t be charged a commission. Rather we\'ll attribute that visit to your stellar marketing skills.<br/><br/> If a new client books you through your Boost listing on Booksy you\'ll be charged a commission on their first visit. As for recurring visits, those are all yours too!',
          },
          'boost-landing-page': {
            'title': 'Get to know more about Boost!',
            'subtitle': 'Here you will find a ton of useful information about the Booksy Boost feature. ',
            'cta': 'Find out more about Boost',
          },
          'boost-help': {
            title: 'Get Help',
          },
        },
        invite: {
          'import': 'Import',
          'add-from-contacts': 'Add from contacts',
          'invite-again': 'Invite to book',
        },
        'menu-text': 'Not seeing everything you need? You may not have the appropriate permissions. Please check in with a Manager.',
      },

      'partner-app': {
        'suspend-modal': {
          'title': 'Request has been submitted',
          'subtitle': 'A member of our Customer Success team will be in touch shortly to finalize app suspension. Until that time you will still be able to use app {partnerName}.',
        },
        'blocked-title': 'Partner app is blocked',
        'blocked-text': 'To activate it, please contact Customer Success team.',
        'turn-off': 'Turn off',
        'turn-off-modal': {
          'title': 'Suspend app {partnerName}?',
          'btn-1-text': 'Suspend app',
          'btn-2-text': 'Go Back',
        },
        'status': {
          'active': 'active',
          'suspended': 'suspended',
          'paid': 'paid',
          'blocked': 'blocked',
          'disabled': 'disabled',
        },
        'booksy-med': {
          'alert-message': 'To start using Booksy Med, you need to <u>subscribe</u> to Booksy Biz',
        },
      },
    },

    onboarding: {
      'access-denied': 'Invalid email or password. Please try again!',
      'login-in-to-your-account': 'Log in to your account',
      'sign-in-to-your-account': 'Sign in to your Booksy account',
      'slide-1-title': 'You\'ve built a business doing things your way.',
      'slide-1-description': 'You love it, but managing the day-to-day, keeping clients in the loop, and marketing your skills slows your momentum.',
      'slide-2-title': 'We\'re your partner, your sidekick, your employee of the month. ',
      'slide-2-description': 'Booksy does more than just appointments. Let us help you streamline all of that extra work so that you can focus on doing what you love.',
      'slide-3-title': 'We help you be you, only better.',
      'slide-3-description': 'You\'ve got the talent. Now we\'ll give you the tools to help you run your business and get you to where you\'re going. Wherever that may be.',
      'slide-4-title': 'Michael Kelley testimonial',
      'slide-4-description': 'Booksy is hands down the most professional move anyone could make in their career. It has been an invisible personal assistant to me for years now.<br><br>– M.R.K. The barber, El Paso',
      'slide-5-title': 'Naja Nail Guru testimonial',
      'slide-5-description': 'Booksy can protect your business and bottomline. I love the marketing and deposit features. Monthly it may pay for itself by collecting deposits and protecting me from no show clients. The text & e-blast marketing templates feature saves so much time so as a small business owner I can focus more on my clients.<br><br>– Queen Naja, Naja Nail Guru, West Hollywood',
      'slide-6-title': 'Luis & Kristen Testimonial',
      'slide-6-description': 'We love Booksy because it allows our clients to book any day, any time while still allowing us to control and keep track of our books, set a specific schedule to accommodate our busy lifestyles<br><br>– Luis Chevere & Kristen Michelle, NOW Salon, San Antonio',
      email: 'Email',
      'enter-email': 'Enter your email address',
      'enter-password': 'Enter your password',
      password: 'Password',
      'forgot-password-question': 'Forgot password?',
      'do-not-have-an-account': 'Do not have an account?',
      'log-in': 'Log in',
      'sign-in': 'Sign in',
      'sign-up': 'Sign up',
      'continue-with-facebook': 'Continue with Facebook',
      'forbidden': {
        'cant-use-frontdesk': {
          'title': 'Early Access is by <br> Invite Only',
          'text-0': 'At this time Early Access to the new Booksy experience is by invite only.',
          'text-1': 'If you\'re an existing Booksy Provider who would like a sneak peak of what\'s coming, give us a shout:',
          'text-2': 'For now, continue to use Booksy Biz to manage your business and empower your customers to book themselves.',
          'button': 'Use Booksy Biz',
        },
      },
    },

    shifts: {
      'day': 'Day',
      'week': 'Week',
      'staff': 'Staff',
      'resources': 'Resources',
      'today': 'Today',
      'current-week': 'Current Week',
      'copy': 'Copy',
    },

    'inventory': {
      'products-tab': 'Products',
      'documents-tab': 'Documents',
      'ecommerce-tab': 'Store',
      'brands-tab': 'Brands',
      'orders-tab': 'My orders',
      'suppliers-tab': 'Suppliers',
      'storage-locations-tab': 'Storage locations',
      'stock-take-tab': 'Stock take',
      'deliveries': 'Deliveries',
      'brands': {
        'details': {
          'new-brand': 'New Brand',
          'brand-name': 'Brand Name',
          'subheader': 'Photo',
          'products': 'Products',
          'search-placeholder': 'Search products',
          'add-photo': 'Add photo',
          'avatar-cropper-description': 'Use your finger or mouse to reposition your image so it fits within the circle.<br/> Also make sure the image looks clear.',
          'upload-new-photo': 'upload new photo',
          'remove-photo': 'remove photo',
          'remove-brand': 'Delete Brand?',
          'remove-brand-description': 'Are you sure? Products are assigned to this brand.',
        },
        'list': {
          'brands': 'Brands',
          'no-documents': 'No documents',
          'no-brands': 'No Brands Added...',
          'products-count': '{count} product | {count} products | {count} products',
        },
      },
      'ecommerce': {
        'store-badge': 'store',
        'new-badge': 'new',
      },
      'orders': {
        title: 'My orders',
        subheading: 'Stock orders from your suppliers',
        'list': {
          'date': 'Date',
          'type': 'Type',
          'number': 'Number',
          'items': 'Items',
          'in-progress': 'In progress',
          'supplier-name': 'Supplier',
          'order-again': 'Order again',
          'gross-price': 'Value gross',
          'net-price': 'Value net',
        },
        'details': {
          'title': 'Document details',
          'shipping': {
            'title': 'Delivery address',
          },
          'billing': {
            'title': 'Invoice details',
          },
          'contact-supplier': 'If you have any questions or doubts regarding your order, please contact the Supplier',
          'applied-discount-code': 'Applied discount code: {code}',
        },
      },
      'documents': {
        'details': {
          'items': 'Items',
          'expand': 'Expand',
          'add-item': 'Add item',
          'fill-up': 'Fill up to maximum stock',
          'fill-up-error': 'Products from the selected supplier have full stock',
          'added-product-error': 'This product has already been added to Stocktake Records',
          'total-net': 'Total net',
          'total-gross': 'Total gross',
          'total': 'Total',
          'net': 'net',
          'to-stock-order': 'to Stock Order',
        },
        'list': {
          'date': 'Date',
          'type': 'Type',
          'number': 'Number',
          'items': 'Items',
          'in-progress': 'In progress',
        },
        'mixins': {
          'documents': {
            'all-documents': 'All documents',
            'stock-request-confirmation': 'Stock Request Confirmation',
            'internal-product-expenditure': 'Internal Product Expenditure',
            'internal-stock-transfer': 'Internal Stock Transfer',
            'stock-intake-confirmation': 'Stock Intake Confirmation',
            'stock-order': 'Stock Order',
            'supply': 'Supply',
            'stocktake-record': 'Stocktake Record',
            'shortcuts': {
              'all-documents': '',
              'stock-request-confirmation': 'SR',
              'internal-product-expenditure': 'PE',
              'internal-stock-transfer': 'ST',
              'stock-intake-confirmation': 'SI',
              'stock-order': 'SO',
              'supply': 'S',
              'stocktake-record': 'STR',
            },
            'subheadings': {
              'all-documents': '',
              'stock-request-confirmation': 'Confirmation of stock sales.',
              'internal-product-expenditure': 'Removes products from your stock e.g damaged stock.',
              'internal-stock-transfer': 'Moving stock from one storage location to a diffrerent storage location.',
              'stock-intake-confirmation': 'Confirms receipt of products and increases the stock quantity.',
              'stock-order': 'Stock orders from your suppliers.',
              'supply': 'Confirms receipt of stock orders from your suppliers.',
              'stocktake-record': 'Allows the business to create a digital version of their stocktake.',
            },
          },
        },
      },
      'products': {
        'details': {
          'new-product': 'New Product',
          'archived': 'Archived',
          'activate': 'Activate',
          'open-in-store': 'Shop this item',
          'product-activated': 'Product activated',
          'details-tab': 'Details',
          'photos-tab': 'Photos',
          'description-tab': 'Description',
          'suppliers-tab': 'Suppliers',
          'location-tab': 'Stock & Storage Location',
          'history-tab': 'History',
          'delete-modal-title': 'This product is assigned to many warehouses',
          'delete-modal-text': 'Select warehouses you want to remove this product from or delete whole product.',
          'delete-whole-product': 'Delete whole product',
          'delete-from-warehouses': 'Delete from selected warehouses',
          'no-warehouse-selected': 'No warehouses selected',
          'delete-product': 'Delete product?',
          'delete-description': 'This action cannot be undone',
          'save-product': 'Save product?',
          'save-product-description': 'You\'ve made some changes. Do you want to save them before leaving?',
          'save-reject': 'Leave without saving',
          'minimum-packages-error': 'The minimum level is higher than the maximum level',
          'maximum-packages-error': 'The maximum level is lower than the minimum level',
          'product-deleted': 'Product deleted',
          'description': {
            'product-description': 'Product description',
          },
          'details': {
            'product-name': 'Product name',
            'catalog-name': 'Catalog name',
            'brand': 'Brand',
            'product-type': 'Product type',
            'product-type-hint': 'Professional products are supplies that you use internally. Retail products are items that you sell to your customers.',
            'all-products': 'All products',
            'main-category': 'Main category',
            'status': 'Status',
            'other-categories': 'Other categories',
            'sku': 'SKU',
            'add-barcode': 'Add barcode',
            'edit-barcode': 'Edit barcode',
            'price': 'Price',
            'tax-rate': 'Tax rate',
            'retail-price': 'Retail price (with Tax)',
            'measure-units': 'Measure units',
            'units-per-piece': 'Units per 1 pc',
            'active': 'Active',
            'archived': 'Archived',
            'professional': 'Professional',
            'retail': 'Retail',
            'barcode': 'Barcode',
            'cover-photo': 'Product Photo',
            'show-all': 'Show all',
            'empty-brands': 'No brands added yet…',
            'add-brand': 'Add Brand',
            'barcode-empty': 'Scan or add bar code',
          },
          'photos': {
            'add-photo': 'Add photo',
            'photo-description': 'Adjust the size of the grid to crop your image. You can also drag your photo to reposition it.',
            'add-media': 'Add media',
          },
          'location': {
            'location': 'Location',
            'stock-units': 'Stock (units)',
            'stock-pcs': 'Stock (pcs)',
            'pcs': 'PCs',
            'minimum-level': 'Minimum level',
            'maximum-level': 'Maximum level',
            'history': 'History',
            'retail': 'Retail',
            'professional': 'Professional',
            'empty-state': 'No Storage Locations Added...',
            'add-button': 'Add Storage Location',
            'enable-stock-control': 'Enable stock control',
            'stock-control-info': 'Stock control is disabled. Please visit Business Settings > Payments & Checkout > Checkout Settings > Retail Settings > Enable stock control > Save to make adjustments.',
            'stock-on-hand-pcs': 'Stock on hand (pcs)',
            'stock-on-hand-units': 'Stock on hand (units)',
            'empty-description': 'Product has not been added to any storage location yet',
            'empty-cta': 'Increase stock level',
          },
          'suppliers': {
            'empty-state': 'No Suppliers Added...',
            'add-button': 'Add Supplier',
          },
        },
        'list': {
          'categories': 'Categories',
          'all-products': 'All products',
          'search-results': 'Search results',
          'search-placeholder': 'Search products',
          'archived': 'Archived',
          'activated': 'Activated',
          'deleted': 'Deleted',
          'no-results-title': 'No products match your search...',
          'no-products-title': 'No products in this category. Tap on “+” button to add one.',
          'confirm-archive-title': 'Archive this product?',
          'confirm-archive-description': 'Archived products are not displayed on the product list during the checkout process. Are you sure you want to archive this product?',
          'confirm-archive-submit': 'Archive',
        },
      },
      'storage-locations': {
        'header-edit': 'Edit Storage Location',
        'header-add': 'Add Storage Location',
        'details': {
          'products-on-stock': 'No. of items',
          'location-report': 'Send report',
          'products': 'Products',
          'search-placeholder': 'Search products',
          'available-stock': 'Available Stock Report',
          'low-level-stock': 'Low Stock Level Report',
          'raport-sent': 'Report was sent to email {email}',
          'no-products-title': 'No products available in this stock',
        },
        'list': {
          'location': 'Location',
          'stocks': 'Stock',
          'unit': 'products',
          'total-report': 'Total report',
          'default': 'Default',
        },
        'consts': {
          'professional': 'Professional',
          'retail': 'Retail',
          'other': 'Other',
        },
      },
      'suppliers': {
        'details': {
          'new-supplier': 'New Supplier',
          'remove-supplier': 'Delete Supplier?',
        },
        'list': {
          'header': 'Suppliers',
          'no-documents': 'No documents',
          'no-suppliers': 'No Suppliers Added...',
        },
      },
    },
    settings: {
      performance: {
        subtitle: 'Choose how Booksy renders your calendar',
        auto: {
          title: 'Automatic',
          text: 'Let Booksy choose the best solution depending on your business type',
        },
        immediate: {
          title: 'Immediate',
          text: 'Render the whole calendar as fast as possible',
        },
        optimized: {
          title: 'Optimized',
          text: 'Best for slower devices. Renders only visible parts of calendar',
        },
      },
    },

    sandbox: {
      hello_world: 'hello, world',
      value_of: 'value: {value}',
      kaliber_44: '<b>bold</b> black cat',
      liquid_paper: 'liquid paper',
      plural_form: '{count} apple | {count} apples | {count} apples',
    },

  },

  /*
   *
   * routes
   *
   */
  routes,

  /*
   *
   * store
   *
   */
  'store': {
    'business': {
      'tax-free': 'Tax Free',
    },
  },

  /*
   *
   * common messages...
   *
   */
  yes: 'yes',
  no: 'no',
  language: 'language',
  country: 'country',
  'got-it': 'Got it',
  'ok-got-it': 'Ok, got it',
  'ok': 'Ok',
  'contact-customer-support': 'Contact Customer Support',
  'contact-us': 'Contact us',
  delete: 'Delete',
  cancel: 'Cancel',
  disable: 'Disable',
  closed: 'Closed',
  continue: 'Continue',
  close: 'Close',
  'open': 'Open',
  share: 'Share',
  download: 'Download',
  'share-on-instagram': 'Share on Instagram',
  'delete-photo': 'Delete photo',
  save: 'Save',
  remove: 'Remove',
  checkout: 'Checkout',
  confirm: 'Confirm',
  'save-draft': 'Save draft',
  'save-and-finish': 'Save and finish',
  reject: 'Reject',
  accept: 'Accept',
  agree: 'Agree',
  clear: 'clear',
  edit: 'Edit',
  details: 'Details',
  send: 'Send',
  change: 'Change',
  submit: 'Submit',
  'send-to-client': 'Send to Client',
  'deleted': 'Deleted',
  'discard': 'Discard',
  'saved': 'Saved',
  'save-changes': 'Save changes',
  'search': 'Search',
  'go-back': 'Go Back',
  'go-to-settings': 'Go to settings',
  'not-allow': 'Don\'t allow',
  'ask-me-later': 'Ask me later',
  'back': 'Back',
  'not-now': 'Not now',
  'retry': 'Retry',
  'yes-save-changes': 'Yes, save changes',
  'oops-no': 'Oops, no',
  'yes-remove': 'Yes, remove',
  'yes-discard': 'Yes, discard',
  'yes-abort': 'Yes, abort',
  'yes-continue': 'Yes, continue',
  'yes-delete': 'Yes, delete',
  'no-revert-changes': 'No, revert changes',
  'revert-changes': 'Revert changes',
  'no-results': 'No results found',
  'check-your-spelling': 'Check your spelling and try again.',
  'start-typing': 'Start typing',
  'sent': 'Sent',
  'try-again': 'Try again',
  or: 'or',
  to: 'to',
  from: 'from',
  till: 'till',
  add: 'Add',
  upload: 'Upload',
  apply: 'Apply',
  select: 'Select',
  hide: 'Hide',
  show: 'Show',
  'not-set': 'Not set',
  'not-allowed': 'Not allowed',
  stop: 'stop',
  'learn-more': 'Learn more',
  'no-thanks': 'No, thanks',
  'loading': 'Loading...',
  'date-of-birth': 'Date of birth',
  'unsupported-windows': 'This feature is disabled because your Windows operating system is outdated and unsupported. Please upgrade to Windows 10 or 11 to enable it.',

  logout: 'Logout',

  hour_symbol: 'h',
  minute_symbol: 'min',

  copied: 'Copied',
  'copied-to-clipboard': 'Copied to clipboard',
  'can-not-copy': 'Can not copy',

  success: 'Success',
  error: 'Something went wrong... :(',

  'no-show': 'No-show',
  'client-no-show': 'Client No-Show',
  'cancel-no-show': 'Undo "no-show"',
  'cancel-appointment': 'Cancel appointment',
  'cancel-reservation': 'Cancel reservation',
  'confirm-no-show': 'Confirm No-Show',
  'book-again': 'Book again',
  'notify-client': 'Notify client',

  'upcoming': 'Upcoming',
  'past': 'Past',
  'after': 'After',
  enabled: 'Enabled',
  disabled: 'Disabled',
  more: 'More',
  'show-more': 'Show more',
  less: 'Less',
  'show-less': 'Show less',
  rule: 'Rule',
  'required': 'required',
  'optional': 'Optional',

  selected: 'Selected',
  fixed: 'Fixed',
  free: 'Free',
  varies: 'Varies',
  'do_not_show': 'Don\'t show',
  'starts_at': 'Starts at',

  'show-all': 'Show all',
  'select-all': 'Select All',
  'all-selected': 'All selected',
  appointment: 'Appointment',

  'clients': 'Clients',
  'select-a-client': 'Select a client',
  'walk-in-client': 'Walk-in Client',

  'staff': 'Staff',
  'staffer': 'Staffer',
  'select-staffer': 'Select staffer',

  'choose-from-library': 'Choose from library',
  'take-a-photo': 'Take a photo',

  'go-to-calendar': 'Go to calendar',
  'use-booksy-biz': 'Use Booksy Biz',

  day: 'day',
  days: 'days',
  'days-genitive-case': 'days',
  hours: 'hour(s)',
  'hours-genitive-case': 'hours',
  'hours-accusative-case': 'hours',
  'hours-plural': '{count} hour | {count} hours | {count} hours',
  min: 'min',
  minutes: 'minutes',
  'minutes-genitive-case': 'minutes',
  'mm-dd-yyyy': 'mm/dd/yyyy',
  month: 'month',
  months: 'months',
  'months-genitive-case': 'months',
  'months-accusative-case': 'months',
  'years-plural': '{count} year | {count} years | {count} years',
  'seconds-genitive-case': 'seconds',
  'seconds-shortcut': 'sec',
  'microseconds-genitive-case': 'microseconds',
  Wednesday: 'Wednesday',
  week: 'Week',
  Weekly: 'Weekly',
  Weeks: 'Weeks',
  year: 'Year',
  Years: 'Years',
  between: 'between',
  last: 'last',
  today: 'Today',
  yesterday: 'yesterday',
  next: 'next',
  start: 'start',
  'from-to': 'From - to',
  'empty-search-description': 'Please try a different phrase.',
  other: 'Other',
  'done': 'Done',
  'soon': 'Soon',

  'form-errors': {
    'cell-phone': 'Phone number is required',
    'cell-phone-or-email': 'Phone number or email is required',
    'file-to-big': 'File is too big. Max allowed file size is {size} MB',
    'file-wrong-format': 'Wrong file format',
    'too-many-files': 'Too many files. You can upload up to 6 files at once.',
    'min-length': 'This field must be at least {min} characters',
  },

  'appointment-status': {
    'confirmed': 'Confirmed',
    'canceled': 'Cancelled',
    'declined': 'Declined',
    'finished': 'Finished',
    'modified': 'Modified',
    'no-show': 'No-show',
    'client-must-confirm': 'Client must confirm',
    'you-must-confirm': 'You must confirm',
    'rejected': 'Rejected',
    'unverified': 'Unverified',
    'prepayment-awaiting': 'Awaiting deposit',
  },

  'payments-status': {
    'call-for-payment': 'Call for payment',
    'in-progress': 'Not charged',
    'authorized': 'Authorized',
    'sent-for-refund': 'Sent for refund',
    'success': 'Success',
    'refunded': 'Refunded',
    'prepayment': 'Deposit',
    'partial-settlement': 'Partial Settlement',
    'canceled': 'Cancelled',
    'chargeback': 'Chargeback',
    'failed': 'Failed',
    'archived': 'Archived',
    'call-for-deposit': 'Awaiting Deposit',
    'paid': 'Paid',
    'pending': 'Pending',
    'awaiting': 'Awaiting',
    'park-sale': 'Parks Sale',
    'not-charged': 'Not Charged',
    'second-chargeback': 'Second Chargeback',
    'chargeback-reversed': 'Chargeback Reversed',
    'booksy-gift-card': 'Pending payment',
  },

  'remove-address': 'Remove Address?',
  'remove-address-description': 'This action cannot be undone',

  'gift-card': 'Gift Card',
  'package': 'Package',
  'membership': 'Membership',

  'add-ons': '(+Add-ons)',

  'no-permission': 'You have no permission to use this feature',
  'something-went-wrong': 'Something went wrong. Please try again or contact our customer support.',

  'address': {
    'modal-title': 'Address',
    'street': 'Street',
    'street-address': 'Street address & number',
    'suite-number': 'Suite Number (optional)',
    'city': 'City',
    'zip-code': 'Zip code',
  },

  'youre-offline': 'You\'re currently offline',
  'connection-problem': 'There was a connection problem.',
  'reset': 'Reset',

  added: 'Added',
  removed: 'Removed',
  'view-picker': {
    day: 'Day',
    week: 'Week',
    month: 'Month',
    agenda: 'Appointment List',
    waitlist: 'Waitlist',
  },

  'need-help': 'Need help?',

  'fake-door': {
    title: 'This feature isn’t available yet.',
    description: 'Thank you for your interest but this feature isn\'t quite ready yet.',
    ok: 'Done',
  },

  'beta': 'Beta',
}
